module.exports = __webpack_public_path__ + "img/arrow-up.9f86129a.svg";